import CodeBlock from '../components/CodeBlock';
import ParameterTable from '../components/ParameterTable';
import PlanBadge from '../components/PlanBadge';
import { pdfParameters } from '../data/parameters';

export default function PDFGeneration() {
  return (
    <section id="pdf" className="mb-16">
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-2xl font-bold text-gray-900">POST /pdf</h3>
        <PlanBadge plan="starter" />
      </div>
      <p className="text-gray-700 mb-6">
        Generate PDF documents from URLs or HTML content with customizable page settings.
        Available on Starter, Growth, and Pro plans.
      </p>

      <h4 className="text-lg font-semibold text-gray-900 mb-3">PDF from URL</h4>
      <CodeBlock section="pdf" />

      <div className="mt-8">
        <h4 className="text-lg font-semibold text-gray-900 mb-3">PDF from HTML</h4>
        <CodeBlock section="pdfHTML" />
      </div>

      <div className="mt-8">
        <h4 className="text-lg font-semibold text-gray-900 mb-3">PDF Parameters</h4>
        <ParameterTable parameters={pdfParameters} />
      </div>
    </section>
  );
}